import * as React from 'react';

import RegionsMap from '../RegionsMap';
import CommonSelect, { CommonSelectWrapperProps } from './CommonSelect';

const RegionSelect = ({
  multiple,
  placeholder = `Please select region${multiple ? 's' : ''}`,
  ...props
}: CommonSelectWrapperProps) => (
  <CommonSelect
    {...{ placeholder, multiple, ...props }}
    values={Object.keys(RegionsMap).map((regionCode) => {
      return { key: regionCode, value: RegionsMap[regionCode] };
    })}
    idKey="key"
    valueFn={(item) => item.value}
  />
);

export default RegionSelect;
